<div class="content-info">
  <div class="content-title">
    <h3 class="title">Add Inventory</h3>
    <!-- <div class="title-actions">
    <button type="submit" class="btn btnprimary w-100">
      <i class="bi bi-plus-lg"></i> Add Inventory
    </button>
  </div> -->
</div>

<!-- Add Inventory Form -->
<form
  [formGroup]="inventoryForm"
  (ngSubmit)="addItemToTable()"
  class="row g-3 align-items-end input-fileds"
  >
  <div class="col-md-2 form-group mb-0">
    <label class="form-label">Product</label>
    <ng-select
      [items]="products"
      bindLabel="name"
      bindValue="id"
      placeholder="-- Select --"
      [searchable]="true"
      formControlName="productId"
      [clearable]="true"
      >
    </ng-select>
  </div>

  <div class="col-md-2 form-group mb-0">
    <label class="form-label">Variant</label>
    <select
      class="form-select form-control"
      formControlName="variantId"
      [disabled]="!variants.length"
      >
      <option value="">-- Select --</option>
      @for (v of variants; track v.id) {
        <option [value]="v.id">{{ v.variantName }}</option>
      }
    </select>
  </div>

  <div class="col-md-2 form-group mb-0">
    <label class="form-label">Location</label>
    <select
      class="form-select form-control"
      formControlName="locationId"
      [disabled]="inventoryItems.length > 0"
      >
      <option value="">-- Select --</option>
      @for (l of locations; track l.id) {
        <option [value]="l.id">{{ l.name }}</option>
      }
    </select>
  </div>

  <div class="col-md-1 form-group mb-0">
    <label class="form-label">Qty</label>
    <input type="number" class="form-control" formControlName="quantity" />
  </div>

  <div class="col-md-1 form-group mb-0">
    <label class="form-label">Outer Pkg</label>
    <input
      type="number"
      class="form-control"
      formControlName="outerPackaging"
      />
    </div>

    <div class="col-md-2 form-group mb-0">
      <label class="form-label">Batch No</label>
      <input type="text" class="form-control" formControlName="batchNumber" />
    </div>

    <div class="col-md-2 form-group mb-0">
      <label class="form-label">Expiry</label>
      <input type="date" class="form-control" formControlName="expiryDate" />
    </div>

    <div class="col-md-2">
      <button type="submit" class="btn btnprimary w-100">
        <i class="bi bi-plus-lg"></i> Add Inventory
      </button>
    </div>
  </form>

  <!-- Inventory Table -->
  @if (inventoryItems.length) {
    <div class="common-table mt-4">
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th>#</th>
              <th>Product</th>
              <th>Variant</th>
              <th>Quantity</th>
              <th>Batch</th>
              <th>Expiry</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            @for (item of inventoryItems; track item.variantId) {
              <tr>
                <td>{{ inventoryItems.indexOf(item) + 1 }}</td>
                <td>{{ item.productName }}</td>
                <td>{{ item.variantName }}</td>
                <td>{{ item.quantity | number : "1.0-3" }}</td>
                <td>{{ item.batchNumber || "-" }}</td>
                <td>{{ item.expiryDate }}</td>
                <td>
                  <div class="td-actions-btn">
                    <button
                      class="btn btn-trash"
                      (click)="removeItem(inventoryItems.indexOf(item))"
                      >
                      <i class="bi bi-trash3"></i>
                    </button>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-end mt-3">
        <button class="btn btnprimary" (click)="submitInventory()">
          Submit Inventory
        </button>
      </div>
    </div>
  }
</div>
